import React from 'react';

import ManualAchContainer from '../ManualACH/container';
import MorganStanleyACH from './MorganStanleyACH';

import Plaid from '../Plaid';
import { BaseFundingAccountProps } from '../shared';

import css from '../FundingAccount.module.scss';

export interface MSFundingAccountProps extends BaseFundingAccountProps {
  hideManualACH: boolean | undefined;
  showPlaid: boolean;
  setShowPlaid: (state: boolean) => void;
  fee: number;
}

export default function MorganStanley({
  hideManualACH,
  showPlaid,
  fundingSource,
  setShowPlaid,
  setFundingSource,
  getInitialFundingAmount,
  submitPaymentMethod,
  fee
}: MSFundingAccountProps) {
  return (
    <>
      {!hideManualACH && (
        <div
          className={`${css.AddFundingAccountContainer} ${css.ManualACHPrimaryFunding}`}
          data-e2e="manual-ach"
          data-testid="manual-ach-container"
        >
          <MorganStanleyACH
            fundingSource={fundingSource}
            setFundingSource={setFundingSource}
            fee={fee}
          />

          {fundingSource === 'ach' && (
            <ManualAchContainer
              fundingSource={fundingSource}
              setFundingSource={setFundingSource}
              getInitialFundingAmount={getInitialFundingAmount}
              submitPaymentMethod={submitPaymentMethod}
              isMorganStanleyFlow={true}
            />
          )}
        </div>
      )}
      {showPlaid && (
        <Plaid
          isMorganStanleyFlow={true}
          setShowPlaid={setShowPlaid}
          setFundingSource={setFundingSource}
          getInitialFundingAmount={getInitialFundingAmount}
          submitPaymentMethod={submitPaymentMethod}
        />
      )}
    </>
  );
}
